// @flow
import { Component } from 'react';
import context from 'app/common/lib/context';
import ContextEvent from 'app/common/lib/ContextEvent';
import ContextLogger from 'app/common/lib/ContextLogger';

type Props = {
  log: ?Object,
  children?: *,
};

/**
 * Component that logs View events to ContextLogger on mount.
 * This has a side effect of setting ContextLogger._currentViewContext.
 */
export default class View extends Component<Props> {
  componentDidMount() {
    const { log } = this.props;
    if (log) {
      const contextEvent = ContextEvent.fromPlainObject(log);
      contextEvent.setEventType(PCONST.thrift.EventType.VIEW);
      contextEvent.setRequestIdentifier(context.initialPageContext.PAGE_LOAD_REQUEST_IDENTIFIER);
      // TODO(jchan): Implement this when this is needed. `current` refers to current Denzel module
      //              Redux `contextLogging` slice would be good place to put this instead of in component
      // const objectId = current.getLoggingObjectIdStr();
      // if (objectId) {
      // contextEvent.setObjectIdStr(objectId);
      // }
      ContextLogger.getInstance().addEvent(contextEvent);
    }
  }

  render() {
    return this.props.children || null;
  }
}
